export default __webpack_public_path__ + "static/media/vermont.189ddd6b.jpg";